import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SystemApiService } from '@cv-invision/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LenderMapper, LenderModel } from '../lender/model/lender.model';

@Injectable()
export class LenderService {
	private setReloadlListConfirmation = new BehaviorSubject({});
	private getReloadlListListener = this.setReloadlListConfirmation.asObservable();
	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {}
	/**
	 * GET - Return list of organizations based on a provider.
	 */
	getLenderConfiguration(filter : any): Observable<any> {
		let httpParams: any = new HttpParams();
		const { pagination, searchTextAcuityName, searchTextScopeName } = filter;
		if (searchTextAcuityName) {
			httpParams = httpParams.append('AcuityBranchName', searchTextAcuityName);
		}
		if (searchTextScopeName) {
			httpParams = httpParams.append('AppScopeClientName', searchTextScopeName);
		}
		if (pagination) {
			const { limit, offset } = pagination;
			httpParams = httpParams.append('limit', limit.toString());
			httpParams = httpParams.append('offset', offset.toString());
		}

		return this.httpClient.get(`${this.systemApiService.api.orders}/utils/mapper/lenders`, {
			params: httpParams
		});
	}

	/**
	 * GET - Return list acuity lender branches.
	 */
	getAcuityLenderBranches = (title: string = ''): Observable<any> => {
		return this.httpClient.get(`${this.systemApiService.api.orders}/utils/acuity/lenders?title=${title}`);
	}

	/**
	 * GET - Return list cmp acuity lender branches.
	 */
	getCmpAcuityLenderBranches = (title: string = ''): Observable<any> => {
		return this.httpClient.get(`${this.systemApiService.api.orders}/utils/cmpacuity/lenders?title=${title}`);
	}

	/**
	 * GET - Return list of lenders
	 */
	getLenders = (title: string = ''): Observable<any> => {
		return this.httpClient.get(`${this.systemApiService.api.orders}/utils/appscope/lenders?title=${title}`);
	}

	/**
	 * Update the Lender Configuration
	 */
	updateLenderConfiguration(params: any): Observable<any> {
		let httpParams = new HttpParams();
		httpParams = httpParams.append('defaultAcuityBranchId', params.defaultAcuityBranchId);
		httpParams = httpParams.append('defaultAcuityBranchIdWhenClass', params.defaultAcuityBranchIdWhenClass);
		return this.httpClient.put(`${this.systemApiService.api.orders}/utils/mapper/lenders?${httpParams.toString()}`,{});
	}

	/**
	 * Update the Lender Configuration
	 */
	createLender(lender: LenderMapper): Observable<any> {
		return this.httpClient.post(`${this.systemApiService.api.orders}/utils/mapper/lenders`, lender);
	}

	/**
	 * Update the Lender Configuration
	 */
	updateLender(newlender: LenderMapper, oldlender: LenderMapper): Observable<any> {
		return this.httpClient.put(`${this.systemApiService.api.orders}/utils/mapper/lender`, {
			newValue: newlender,
			oldValue: oldlender
		});
	}

	deleteLender(lender: any): Observable<any> {
		return this.httpClient.delete(`${this.systemApiService.api.orders}/utils/mapper/lenders`, {body: lender});
	}

	/**
	 * Sets component data communication.
	 * @param data
	 */
	setReloadListConfirmation(data: any): void {
		this.setReloadlListConfirmation.next(data);
	}

	/**
	 * Returns si the list should be reloaded.
	 */
	getReloadListConfirmationListener(): Observable<any> {
		return this.getReloadlListListener;
	}
}
